export class Config {
    constructor($windowProvider, $routeProvider, $locationProvider, toastrConfig, ngMetaProvider) {
      $locationProvider.html5Mode(true);
        let landings = [
            {
                templateUrl: "landing/landing/landing.html",
                css: "css/portable.css",
                controller: "LandingController",
                page: 'landing',
                data: {
                  meta: {
                    description: "Busca Pareja y Amigos en Internet en el sitio más importante y seguro de Chile. Regístrate Gratis en el chat e encuentra hoy mismo pareja o amistades en línea.",
                    keywords: "Buscar pareja, buscando pareja, buscar pareja en internet, buscando pareja en internet, chat, chatear, chatear gratis, chat gratis, busco pareja, busco pareja en línea, busco pareja en internet"
                  }
                }
            },
            {
                templateUrl: "landing/landingA/landingA.html",
                css: ["/landing/css/bootstrap.css", "/landing/css/font-awesome/css/font-awesome.min.css", "/landing/landingA/style.css"],
                controller: "LandingController",
                page: 'landing'
            },
            {
                templateUrl: "landing/landingB/landingB.html",
                css: ["/landing/css/bootstrap.css", "/landing/css/font-awesome/css/font-awesome.min.css", "/landing/landingB/style.css"],
                controller: "LandingController",
                page: 'landing'
            },
            {
                templateUrl: "landing/landingC/landingC.html",
                css: ["/landing/css/bootstrap.css", "/landing/css/font-awesome/css/font-awesome.min.css", "/landing/landingC/style.css"],
                controller: "LandingController",
                page: 'landing'
            },
            {
                templateUrl: "landing/landingD/landingD.html",
                css: ["/landing/css/bootstrap.css", "/landing/css/font-awesome/css/font-awesome.min.css", "/landing/landingD/style.css"],
                controller: "LandingController",
                page: 'landing'
            }
        ];

        $routeProvider
            .when("/", landings[0])
            .when("/landingA", landings[1])
            .when("/landingB", landings[2])
            .when("/landingC", landings[3])
            .when("/landingD", landings[4])
            .when("/eventos", {
                data: {
                  meta: {
                    title: "Eventos de Speed Dating y Fiestas para Solteros/as",
                    description: "Los mejores Eventos para Solteros en Chile, Speed Dating, Citas Rápidas, Fiestas, Asados - Conoce Gente o hasta tu Pareja nueva",
                    keywords: "Fiestas, speed dating, eventos, asados, citas rápidas"
                  }
                },
                templateUrl: "views/eventos.html",
                css: "css/portable.css",
                controller: "SeoController",
                page: 'seo'
            })
            .when("/seo/chat", {
                templateUrl: "views/chat.html",
                css: "css/portable.css",
                controller: "SeoController",
                page: 'seo',
                data: {
                  meta: {
                    title: "Chatea Gratis en línea",
                    description: "Chatea Gratis en línea, busca amigos o pareja en Internet. Entra gratuitamente a nuestras salas de chat para chatear con gente nueva.",
                    keywords: "chat, chatear, chat gratis, chatear gratis, salas de chat, chat en chile, chat en línea, chat por internet, chat libre,"
                  }
                }
            })
            .when("/seo/conocer-gente", {
                templateUrl: "views/conocer-gente.html",
                css: "css/portable.css",
                controller: "SeoController",
                page: 'seo',
                data: {
                  meta: {
                    title: "Conoce Gente de tu área en Internet",
                    description: "Conoce Gente en línea desde tu área. Chatea Gratis con gente en línea ahora mismo. Gente de tu ciudad te esta esperando.",
                    keywords: "Conocer gente, conoce gente, conocer gente en línea, conocer gente por chat, conoce gente por chat, conocer gente de tu área, conoce gente de tu ciudad, chatear con gente, conocer gente nueva."
                  }
                }
            })
            .when("/homerd", {
                templateUrl: "views/home.html",
                css: "css/home.css",
                controller: "HomeController",
                page: 'default'
            })
            .when("/homerd/recomendados", {
                templateUrl: "views/recommended.html",
                css: "css/home.css",
                controller: "RecommendedController",
                page: 'default'
            })
            .when("/homerd/meinteresan", {
                templateUrl: "views/interesting.html",
                css: "css/home.css",
                controller: "InterestingController",
                page: 'default'
            })
            .when("/homerd/interesadosenmi", {
                templateUrl: "views/interested-in-you.html",
                css: "css/home.css",
                controller: "InterestedInYouController",
                page: 'default'
            })
            .when("/homerd/mutuointeres", {
                templateUrl: "views/mutual-interest.html",
                css: "css/home.css",
                controller: "MutualInterestController",
                page: 'default'
            })
            .when("/homerd/lastvisits", {
                templateUrl: "views/last-visits.html",
                css: "css/home.css",
                controller: "LastVisitsController",
                page: 'default',
                reloadOnSearch: false
            })
            .when("/homerd/newfaces", {
                templateUrl: "views/new-users.html",
                css: "css/home.css",
                controller: "NewUsersController",
                page: 'default',
                reloadOnSearch: false
            })
            .when("/homerd/online", {
                templateUrl: "views/online.html",
                css: "css/home.css",
                controller: "OnlineController",
                page: 'default',
                reloadOnSearch: false
            })
            .when("/homerd/birthday", {
                templateUrl: "views/birthday.html",
                css: "css/home.css",
                controller: "BirthdayController",
                page: 'default',
                reloadOnSearch: false
            })
            .when("/homerd/centrodepago", {
                templateUrl: "views/payment-center.html",
                css: "css/home.css",
                controller: "PaymentCenterController",
                page: 'payment_panel'
            })
            .when("/homerd/webpayredirect", {
                templateUrl: "views/payment-webpay.html",
                css: "css/home.css",
                controller: "WebpayController",
                page: 'payment_panel'
            })
            .when("/homerd/webpayredirect/token/:token/url/:url", {
                templateUrl: "views/payment-webpay-redirect.html",
                css: "css/home.css",
                controller: "WebpayRedirectController",
                page: 'payment_panel'
            })
            .when("/homerd/payment-process", {
                templateUrl: "views/payment_process.html",
                css: "css/home.css",
                controller: "PaymentProcessController",
                page: 'payment_panel'
            })
            .when("/homerd/paypal", {
                templateUrl: "views/payment_paypal.html",
                css: "css/home.css",
                controller: "PaymentPayPalController",
                page: 'payment_panel'
            })
            .when("/homerd/stripe", {
                templateUrl: "views/payment_stripe.html",
                css: "css/home.css",
                controller: "PaymentStripeController",
                page: 'payment_panel'
            })
            .when("/homerd/centrodepago/fail", {
                templateUrl: "views/payment-fail.html",
                controller: "PaymentFailController",
                css: "css/home.css",
                page: 'payment_panel'
            })
            .when("/homerd/centrodepago/success", {
                templateUrl: "views/payment-success.html",
                controller: "PaymentSuccessController",
                css: "css/home.css",
                page: 'payment_panel'
            })
            .when("/homerd/suscripcion/regalo", {
                templateUrl: "views/subscription-gift.html",
                controller: "SubscriptionGiftController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/profilerd/profile/id/:id", {
                templateUrl: "views/profile.html",
                controller: 'ProfileController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/redirect/:params?", {
                css: "css/home.css",
                page: 'default'
            })
            .when("/profilerd/album/id/:id", {
                templateUrl: "views/album.html",
                controller: 'AlbumController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/profilerd/edit-filters", {
                templateUrl: "views/filter-edit.html",
                controller: 'FilterEditController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/profilerd/edit-profile", {
                templateUrl: "views/edit-profile.html",
                controller: "EditProfileController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/forbidden", {
                templateUrl: "views/forbidden.html",
                css: "css/home.css",
                page: 'default'
            })
            .when("/profilerd/edit-profile-photo", {
                templateUrl: "views/edit-profile-photo.html",
                controller: "EditProfilePhotoController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/profilerd/edit-album", {
                templateUrl: "views/edit-album.html",
                controller: "EditAlbumController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/profilerd/configuracion", {
                templateUrl: "views/edit-preferences.html",
                controller: "EditPreferencesController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/profilerd/bloqueado", {
                templateUrl: "views/locked-users.html",
                controller: "LockedUsersController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/eventord", {
                templateUrl: "views/events.html",
                controller: "EventsController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/eventord/index", {
                templateUrl: "views/events.html",
                controller: "EventsController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/eventord/mis-eventos", {
                templateUrl: "views/events.html",
                controller: 'EventsController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/eventord/inscrito", {
                templateUrl: "views/events.html",
                controller: 'EventsController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/eventord/pasados", {
                templateUrl: "views/events.html",
                controller: 'EventsController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/eventord/inscritosevento/:id", {
                templateUrl: "views/event-users.html",
                controller: "EventUsersController",
                css: "css/home.css",
                page: 'default',
                reloadOnSearch: false
            })
            .when("/eventord/informacion/id/:id", {
                templateUrl: "views/event-page.html",
                controller: "EventPageController",
                css: "css/home.css",
                page: 'default'
            })
            .when("/eventord/create-event", {
                templateUrl: "views/create-event.html",
                controller: 'CreateEventController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/blogrd", {
                templateUrl: "views/blogs.html",
                controller: 'BlogsController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/blogrd/index", {
                templateUrl: "views/blogs.html",
                controller: 'BlogsController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/blogrd/miblog", {
                templateUrl: "views/blogs.html",
                controller: 'BlogsController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/blogrd/index/op/ranking", {
                templateUrl: "views/blogs.html",
                controller: 'BlogsController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/blogrd/index/op/me", {
                templateUrl: "views/blogs.html",
                controller: 'BlogsController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/blogrd/create-blog", {
                templateUrl: "views/create-blog.html",
                controller: 'BlogCreateController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/blogrd/blog-detail/id/:id", {
                templateUrl: "views/single-blog.html",
                controller: 'SingleBlogController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/homerd/search", {
                templateUrl: "views/search.html",
                controller: 'SearchController',
                css: "css/home.css",
                page: 'default'
            })
            .when("/homerd/filtered/:filter", {
                templateUrl: "views/filtered-users.html",
                controller: 'FilteredUsersController',
                css: "css/home.css",
                page: 'default'
            })
            // admin-main.html is the admin shell: index.html includes it, and it hosts
            // the ng-view that every /admin/* page renders into. Pointing this route at
            // that same shell made ng-view render the shell inside its own right panel,
            // over and over. Land on the page the navbar already calls "Dashboard".
            .when("/admin", {
                redirectTo: "/admin/approve-profile-photos"
            })
            .when("/admin/approve-profile-photos", {
                templateUrl: "views/admin/admin-approve-profile-photos.html",
                controller: "AdminApproveProfilePhotosController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/approve-album-photos", {
                templateUrl: "views/admin/admin-approve-album-photos.html",
                controller: "AdminApproveAlbumPhotosController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/approve-blogs", {
                templateUrl: "views/admin/admin-approve-blogs.html",
                controller: "AdminApproveBlogsController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/approve-events", {
                templateUrl: "views/admin/admin-approve-events.html",
                controller: "AdminApproveEventsController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/approve-profile-texts", {
                templateUrl: "views/admin/admin-approve-profile-texts.html",
                controller: "AdminApproveProfileTextsController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/user-profile-change", {
                templateUrl: "views/admin/admin-user-profile-change.html",
                controller: "AdminUserProfileChangeController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/banner-crud", {
                templateUrl: "views/admin/admin-banner-crud.html",
                controller: "AdminBannerCrudController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/user-reports", {
                templateUrl: "views/admin/admin-user-reports.html",
                controller: "AdminUserReportsController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/comment-reports", {
                templateUrl: "views/admin/admin-comment-reports.html",
                controller: "AdminCommentReportsController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/permanent-contacts", {
                templateUrl: "views/admin/admin-permanent-contacts.html",
                controller: "AdminPermanentContactsController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/campaign", {
                templateUrl: "views/admin/admin-campaign.html",
                controller: "AdminCampaignController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/campaign-template", {
                templateUrl: "views/admin/admin-campaign-template.html",
                controller: "AdminCampaignTemplateController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/payment-chart", {
                templateUrl: "views/admin/admin-payment-chart.html",
                controller: "AdminPaymentChartController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .when("/admin/user-chart", {
                templateUrl: "views/admin/admin-user-chart.html",
                controller: "AdminUserChartController",
                css: ['css/admin/admin.css'],
                page: 'admin'
            })
            .otherwise("/homerd");

        $locationProvider.hashPrefix('!');
        $locationProvider.html5Mode(true);

        ngMetaProvider.setDefaultTitle('Buscar amor en internet | Buscar pareja en línea | Datingchile');
        ngMetaProvider.setDefaultTag('description', 'Busca Pareja y Amigos en Internet en el sitio más importante y  seguro de Chile. Regístrate Gratis en el chat e encuentra hoy mismo pareja o amistades en línea.');
        ngMetaProvider.setDefaultTag('keywords', 'Buscar pareja, buscando pareja, buscar pareja en internet, buscando pareja en internet, chat, chatear, chatear gratis, chat gratis, busco pareja, busco pareja en línea, busco pareja en internet');

        angular.extend(toastrConfig, {
            allowHtml: true
        });
    }
}
